var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconPeople = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9969 11.3568C13.4543 11.3568 14.5989 10.1578 14.5989 8.65456C14.5989 7.21692 13.4355 6 11.9969 6C10.5582 6 9.38859 7.22289 9.40109 8.66052C9.40735 10.1578 10.5457 11.3568 11.9969 11.3568ZM4.66615 11.4881C5.92963 11.4881 6.93041 10.4382 6.93041 9.13178C6.93041 7.87907 5.91712 6.82321 4.66615 6.82321C3.41517 6.82321 2.39562 7.88503 2.40188 9.13774C2.40813 10.4382 3.3964 11.4881 4.66615 11.4881ZM19.3339 11.4881C20.6036 11.4881 21.5919 10.4382 21.5981 9.13774C21.6044 7.88503 20.5911 6.82321 19.3339 6.82321C18.0829 6.82321 17.0696 7.87907 17.0696 9.13178C17.0696 10.4382 18.0704 11.4881 19.3339 11.4881ZM1.3448 17H5.82955C5.09773 16.0575 5.59812 14.2798 7.21814 13.0033C6.56763 12.6453 5.66693 12.3709 4.66615 12.3709C1.96403 12.3709 0 14.2619 0 15.7652C0 16.5347 0.331509 17 1.3448 17ZM22.6552 17C23.6685 17 24 16.5347 24 15.7652C24 14.2619 22.036 12.3709 19.3339 12.3709C18.3331 12.3709 17.4324 12.6453 16.7819 13.0033C18.4019 14.2798 18.9023 16.0575 18.1704 17H22.6552ZM8.20016 16.994H15.7936C16.9758 16.994 17.3573 16.5944 17.3573 15.962C17.3573 14.4469 15.2369 12.3829 11.9969 12.3829C8.75684 12.3829 6.63644 14.4469 6.63644 15.962C6.63644 16.5944 7.01798 16.994 8.20016 16.994Z",
    fill: "#878793"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconPeople);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-people.5d7f58295c226284e1b6e5fbdb4702a3.svg";